import { AppError } from "../utils/errors";

export class Encryption {
  private shift = 3; // Caesar cipher shift value

  encrypt(text: string): string {
    let result = "";
    for (let i = 0; i < text.length; i++) {
      let charCode = text.charCodeAt(i);
      // Apply Caesar cipher shift
      charCode += this.shift;
      result += String.fromCharCode(charCode);
    }
    // Encode to Base64
    return btoa(result);
  }

  decrypt(encryptedData: string): string {
    try {
      // Decode from Base64
      const text = atob(encryptedData);
      let result = "";
      for (let i = 0; i < text.length; i++) {
        let charCode = text.charCodeAt(i);
        // Reverse Caesar cipher shift
        charCode -= this.shift;
        result += String.fromCharCode(charCode);
      }
      return result;
    } catch (err) {
      const appErr = new AppError(err);
      appErr.setAction("encryption.decrypt");
      appErr.setApiAction("decrypt(encryptedData)");
      appErr.logError("encryption.decrypt");
      return "";
    }
  }

  isEncrypted(text: string): boolean {
    try {
      // Check if the text can be Base64 decoded
      atob(text);
      return true;
    } catch {
      return false;
    }
  }

  // No need for other methods like clearCache, cleanExpiredCache, destroy
}

export const encryption = new Encryption();
